export default __webpack_public_path__ + "images/IY.0299278.png";